














































































import {CommonMixin} from "@/shared/services/mixin";
import {mixins} from "vue-class-component";
import {Component} from "vue-property-decorator";
import cloneDeep from "lodash/cloneDeep";
import {Lading} from "@/interfaces/entity";
import {WarehouseStore} from "@/modules/warehouses/store";
import debounce from "lodash/debounce";
import {scanBillLadingNeedStockIn} from "../../services";
import {union} from "lodash";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import moment from 'moment';
import StockInSearch from "@/modules/warehouses/StockIn/components/Search.vue";
import SuggestNeedStockInTable from "@/modules/warehouses/StockIn/components/SuggestTable.vue";

const form = {
    ladingRowGuids: [] as any
};
@Component({
    name: 'StockInNormal',
    components: {SuggestNeedStockInTable, StockInSearch, AInputBarCode}
})
export default class extends mixins(CommonMixin) {
    moment = moment;
    loadingStockIn = false;
    visibleStockInFast = false;
    columns = [
        {
            title: "STT",
            dataIndex: "stt",
            key: "stt",
            width: 50,
            fixed: 'left'
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            scopedSlots: {customRender: "ladingCode"},
            width: 150,
            ellipsis: true,
            fixed: 'left'
        },
        {
            title: "SK",
            dataIndex: "boxQuantity",
            key: "boxQuantity",
            width: 80,
            ellipsis: true
        },
        {
            title: "TL(g)",
            dataIndex: "weightTemp",
            key: "weightTemp",
            scopedSlots: {customRender: "weightTemp"},
            width: 100,
            ellipsis: true
        },
        {
            title: "TLTC(g)",
            dataIndex: "weight",
            key: "weight",
            scopedSlots: {customRender: "weight"},
            width: 100,
            ellipsis: true
        },
        {
            title: "Địa chỉ nhận",
            dataIndex: "locationTo",
            key: "locationTo",
            scopedSlots: {customRender: "locationTo"},
            width: 500,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        },
        {
            title: "Thao tác",
            dataIndex: "rowGuid",
            key: "rowGuid",
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 100,
            fixed: 'right'
        }
    ];
    private form = cloneDeep(form);

    formLading = {
        ladingCode: undefined,
        weightTemp: undefined,
        weight: undefined,
        boxQuantity: undefined,
    };

    scannedLading: Lading | undefined;

    created() {
        WarehouseStore.clearStockInLadings();
    }

    get ladings() {
        return WarehouseStore.stockInLadingIds.map((id: string, index) => ({
            ...WarehouseStore.stockInLadings[id],
            stt: index + 1
        }));
    }

    get totalLadings() {
        return WarehouseStore.stockInLadingIds.length;
    }

    // onSelectChange(selectedRowKeys: string[]) {
    //     this.form.ladingRowGuids = selectedRowKeys as any;
    // }

    onChangeLadingCode(evt: any) {
        const val = evt.target.value;
        this.formLading = {
            ...this.formLading,
            weightTemp: undefined,
            weight: undefined,
            boxQuantity: undefined,
        } as any;
        if (!val) return;
        this.handleChangeLadingCode(val, this);
    }

    handleChangeLadingCode = debounce(async (ladingCode: any, vm: any) => {
        try {
            const {data} = await scanBillLadingNeedStockIn(ladingCode, WarehouseStore.stockInParams);
            vm.scannedLading = vm.getProp(data, 'data');
            WarehouseStore.addStockInLading(vm.scannedLading);
            if (vm.scannedLading?.weight && vm.scannedLading?.weightTemp && vm.scannedLading?.boxQuantity) {
                vm.formLading = {} as any;
                (this.$refs.barcode as any).focus();
            } else {
                vm.formLading.weight = vm.scannedLading?.weight || undefined as any;
                vm.formLading.weightTemp = vm.scannedLading?.weightTemp || undefined as any;
                vm.formLading.boxQuantity = vm.scannedLading?.boxQuantity || 1 as any;
                if (!vm.formLading.boxQuantity) {
                    (vm.$refs.formLadingBoxQuantity as any).focus();
                } else if (!vm.formLading.weightTemp) {
                    (vm.$refs.formLadingWeightTemp as any).focus();
                } else if (!vm.formLading.weight) {
                    (vm.$refs.formLadingWeight as any).focus();
                }
            }
            vm.form.ladingRowGuids = vm.scannedLading?.rowGuid ? union(vm.form.ladingRowGuids, [vm.scannedLading?.rowGuid]) : vm.form.ladingRowGuids as any;
        } catch (e) {
            console.log(e);
            vm.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }, 500);

    async updateLading() {
        if (!this.isValidUpdateLading()) return;
        try {
            await WarehouseStore.updateStockInLading({
                rowGuid: this.scannedLading?.rowGuid,
                weight: this.formLading.weight,
                weightTemp: this.formLading.weightTemp,
                boxQuantity: this.formLading.boxQuantity
            });
            (this.$refs.barcode as any).focus();
            this.formLading = {} as any;
            this.$message.success({content: "Cập nhật vận đơn thành công"});
        } catch (e) {
            this.$message.error({content: e.response?.data?.message || "Cập nhật vận đơn thất bại"});
        }
    }

    // deleteLading(id: string) {
    //     const lading = WarehouseStore.stockInLadings[id];
    //     if (lading?.ladingCode === this.formLading.ladingCode) {
    //         this.formLading = {} as any;
    //     }
    //     WarehouseStore.deleteStockInLading([id]);
    //     this.form.ladingRowGuids = this.form.ladingRowGuids.filter((ladingRowGuid: string) => ladingRowGuid != id);
    // }

    async stockIn() {
        if (!this.isValidForm()) return;
        this.loadingStockIn = true;
        try {
            await WarehouseStore.stockIn(this.form);
            this.$message.success({content: "Nhập kho thành công"});
            this.refreshData();
        } catch (e) {
            console.log(e);
            this.$message.error({content: e.response?.data?.message || "Đã có lỗi"});
        }
        this.loadingStockIn = false;
    }

    refreshData() {
        this.formLading = {} as any;
        this.scannedLading = undefined;
        this.form = cloneDeep(form);
    }

    isValidForm() {
        if (!this.form.ladingRowGuids.length) {
            this.$message.error({content: "Quét hoặc nhập mã vận đơn để nhập kho"});
            return false;
        }
        return true;
    }

    isValidUpdateLading() {
        if (!this.scannedLading) {
            this.$message.error({content: "Quét hoặc nhập mã vận đơn để cập nhật"});
            return false;
        }
        if (!this.formLading?.weightTemp) {
            this.$message.error({content: "Nhập TL để cập nhật"});
            return false;
        }
        if (!this.formLading?.weight) {
            this.$message.error({content: "Nhập TL tính cước để cập nhật"});
            return false;
        }
        if (!this.formLading?.boxQuantity) {
            this.$message.error({content: "Nhập số kiện để cập nhật"});
            return false;
        }
        return true;
    }

    acceptStockIn() {
        const ladingAccepted = this.ladings.filter((lading: Lading) => this.form.ladingRowGuids.includes(lading?.rowGuid as any));
        WarehouseStore.setStockInLadings(ladingAccepted);
    }

    nextInput(order: number) {
        if (order === 1) {
            (this.$refs.formLadingWeightTemp as any).focus();
        } else if (order === 2) {
            (this.$refs.formLadingWeight as any).focus();
        }
    }
}
